import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type B2BEmailLoginRequest as SchemaB2BEmailLoginRequest } from '../schemas/B2BEmailLoginRequest';
import { type Error as SchemaError } from '../schemas/Error';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @summary Запросить письмо для входа в кабинет
 */
export const StartB2BEmailLoginContentType = 'application/json' as const;
export type StartB2BEmailLoginRequest = SchemaB2BEmailLoginRequest;
export type StartB2BEmailLoginResponses = LinkCommonErrorResponses & {
    /**
     * @description Вход по почте выключен
     */
    '404': {
        'application/json': SchemaError;
    };
    /**
     * @description Слишком много писем на этот адрес
     */
    '429': {
        'application/json': SchemaError;
    };
};
export type StartB2BEmailLoginResponseSuccess = undefined;
export type StartB2BEmailLoginSearchParams = undefined;
export type StartB2BEmailLoginPathParameters = undefined;
export const StartB2BEmailLoginUrl = '/auth/email' as const;
export const StartB2BEmailLoginMethod = 'POST' as const;
export const getStartB2BEmailLoginUrl = (_params?: StartB2BEmailLoginPathParameters) => StartB2BEmailLoginUrl;
